/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Race_SubInputs */

const en_funnel_ob_race_sub = /** @type {(inputs: Funnel_Ob_Race_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Same 40-page paper. Watch how far each gets in the same time:`)
};

const es_funnel_ob_race_sub = /** @type {(inputs: Funnel_Ob_Race_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El mismo artículo de 40 páginas. Mira cuánto avanza cada uno en el mismo tiempo:`)
};

/**
* | output |
* | --- |
* | "Same 40-page paper. Watch how far each gets in the same time:" |
*
* @param {Funnel_Ob_Race_SubInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_race_sub = /** @type {((inputs?: Funnel_Ob_Race_SubInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Race_SubInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_race_sub(inputs)
	return en_funnel_ob_race_sub(inputs)
});